<template>
  <AppClientSimpleLayout>
    <div class="flex flex-col items-center justify-center min-h-screen bg-white">
      <h1 class="text-4xl md:text-5xl font-bold mb-12 md:my-12 text-center">予備校入校料金</h1>
      <div class="flex flex-col w-full max-w-6xl px-4 md:px-8">
        <div class="flex flex-col md:flex-row gap-8 justify-center items-center flex-grow">
          <button
            class="border-2 rounded-2xl mx-12 text-center text-white shadow-md transition-all duration-300 w-full md:w-80 min-h-[203px] relative"
            :class="isStripeSubscription
              ? 'border-gray-400 bg-gray-400 cursor-default flex items-center justify-center'
              : 'border-CLIENT_PRIMARY_PINK bg-CLIENT_PRIMARY_PINK hover:scale-105 hover:bg-CLIENT_PRIMARY_PINK_HOVER cursor-pointer pt-10'"
            :disabled="isStripeSubscription"
            @click="subscriptionYearly()">
            <div
              class="text-3xl font-bold"
              :class="{ 'mb-4': !isStripeSubscription }">
              合格フルパックプラン<br v-if="isStripeSubscription">
              <span v-if="isStripeSubscription">支払い済み</span>
            </div>
            <div
              v-if="!isStripeSubscription"
              class="text-2xl font-semibold mb-6">
              36,000<span class="text-sm">円</span>
            </div>
            <div
              v-if="!isStripeSubscription"
              class="flex flex-col gap-1 mt-4 pb-1 px-3">
              <span class="text-white text-xs font-semibold text-center">すべての授業アーカイブ・<br class="md:hidden">授業課題の閲覧が可能です</span>
              <span class="text-white text-xs font-semibold text-center whitespace-nowrap mt-1">※お申し込み後、ワーク&問題集を郵送いたします。</span>
            </div>
          </button>
        </div>
        <p class="text-center mt-14 font-bold">⚠️お申し込み後、登録メールアドレスに届くご案内を必ずご確認ください。</p>
        <div class="mt-20 md:mt-40 md:pl-8">
          <button
            class="py-2 px-4 rounded-md font-iroha text-CLIENT_PRIMARY_PINK"
            @click="onClickedBack">
            ＜戻る
          </button>
        </div>
      </div>
    </div>
  </AppClientSimpleLayout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'

defineProps({
  isStripeSubscription: {
    type: Boolean,
    default: false,
  },
})

const publicPortalUrl = usePage().props.value.portal.publicUrl

const onClickedBack = () => {
  window.location.href = publicPortalUrl
}

// 年額プラン
const subscriptionYearly = () => {
  Inertia.post(route('client.subscription', {
    price_id: process.env.MIX_STRIPE_TERAKOYA_YEARLY_PRICE_ID,
  }))
}
</script>

<style scoped>
/* 必要なスタイルのみを残す */
.hover-parent:hover .hover-child {
  background-color: #d1d5db;
}
</style>
